/** Tilion — brand & default SEO copy for the admin dashboard */
export const TILION_BRAND = "Tilion";

export const TILION_DEFAULT_DESCRIPTION =
  "Tilion is a safe social media app for kids. Tilion offers web advertising and a dual-interface dashboard with separate experiences for parents and children — manage accounts, safety, content, and campaigns in one place.";

export const TILION_KEYWORDS =
  "Tilion, social media for kids, kids app, parent dashboard, child dashboard, family safety, web advertising, digital parenting, child accounts, Tilion admin";

export const TILION_TITLE_SUFFIX = ` | ${TILION_BRAND}`;
